











import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';

@Component
export default class CardItem extends Vue {
  @Prop() private editMode!: boolean;
  @Prop() private title!: string;
  @Prop() private color!: string;
  @Prop() private icon!: string;
  @Prop() private index!: number;
}
